module.exports = __webpack_public_path__ + "static/media/BANER v2-small.367c3082.png";